/** Discriminated references for canvas selections. */

export const TARGET_DOMAIN = Object.freeze({
  DOM: 'dom',
  SECTION_CSS: 'section-css'
});

export function domTargetRef(eid) {
  const value = String(eid || '');
  return value ? Object.freeze({ domain: TARGET_DOMAIN.DOM, eid: value }) : null;
}

export function sectionCssTargetRef({ key, locator, expectedFingerprint } = {}) {
  const value = String(key || '');
  if (!value || !locator || typeof locator !== 'object') return null;
  return Object.freeze({
    domain: TARGET_DOMAIN.SECTION_CSS,
    key: value,
    locator: Object.freeze({ ...locator }),
    expectedFingerprint: String(expectedFingerprint || '')
  });
}

export function targetRefFor(payload) {
  const ref = payload?.targetRef;
  if (ref?.domain === TARGET_DOMAIN.DOM && ref.eid) return domTargetRef(ref.eid);
  if (ref?.domain === TARGET_DOMAIN.SECTION_CSS) return sectionCssTargetRef(ref);
  return domTargetRef(payload?.eid);
}

export function isDomTarget(target) {
  return targetRefFor(target)?.domain === TARGET_DOMAIN.DOM;
}

export function isSectionCssTarget(target) {
  return targetRefFor(target)?.domain === TARGET_DOMAIN.SECTION_CSS;
}

export function targetRefKey(ref) {
  if (!ref) return '';
  if (ref.domain === TARGET_DOMAIN.DOM) return `dom:${ref.eid || ''}`;
  if (ref.domain === TARGET_DOMAIN.SECTION_CSS) return `section-css:${ref.key || ''}`;
  return '';
}

export function sameTargetRef(left, right) {
  return targetRefKey(left) !== '' && targetRefKey(left) === targetRefKey(right);
}
